export default __webpack_public_path__ + "static/media/background_aae_hud_factory_section_about.d890bb03.jpg";